import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { Claim } from '../models/Claim';
import { MsalModule, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, AuthenticationResult } from '@azure/msal-browser';
import { AuthHelperService } from '../services/auth-helper.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    RouterModule,
    MsalModule,
    MatTooltipModule
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
  loginDisplay? = false;
  displayName? : string;
  private readonly _destroying$ = new Subject<void>();
  claims: Claim[] = [];


  constructor(
    private readonly authService: MsalService,
    private readonly router: Router,
    private readonly authServiceHelper: AuthHelperService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly authHelper: AuthHelperService
  ) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe((result: AuthenticationResult) => {
      if (result) {
        this.router.navigate(['/layout']);
      }
    });

    this.loginDisplay = this.authServiceHelper.setLoginDisplay();

    let activeAccount = this.authService.instance.getActiveAccount();

    if (activeAccount) {
      this.displayName = activeAccount.name;
    }

    this.authService.instance.enableAccountStorageEvents();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.authHelper.isAuthenticated = true;
        this.loginDisplay = this.authServiceHelper.setLoginDisplay();
        this.authServiceHelper.checkAndSetActiveAccount(); 

        if (this.authService.instance.getAllAccounts().length > 0) {
          this.router.navigate(['/accountMapping']); 
        }
      });
  }

  loginRedirect() {
    this.authServiceHelper.loginRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
